/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GetAllSpaces } from 'services/api/SpacesApi';
import { SpaceRole, TSpaceResponseData, TSpaceState } from 'typings';

export const fetchOwnerSpace = createAsyncThunk(
  'spaces/fetchOwnerSpace',
  async (payload, thunkAPI) => {
    try {
      const response = await GetAllSpaces();
      const ownerSpace = response.data.filter((item) => {
        return item.role === SpaceRole.OWNER;
      });
      return ownerSpace[0] as TSpaceResponseData;
    } catch {
      return thunkAPI.rejectWithValue('failed');
    }
  }
);

const initialSpaceState: TSpaceState = {
  spaceData: null,
  isLoading: false
};

export const spaceSlice = createSlice({
  name: 'space',
  initialState: initialSpaceState,
  reducers: {
    clearSpaceData: (state) => {
      state.spaceData = null;
      state.isLoading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOwnerSpace.fulfilled, (state, action) => {
        state.isLoading = false;
        state.spaceData = action.payload as TSpaceResponseData;
      })
      .addCase(fetchOwnerSpace.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchOwnerSpace.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

// Action creators are generated for each case reducer function
export const { clearSpaceData } = spaceSlice.actions;

export default spaceSlice.reducer;
